// extracted by mini-css-extract-plugin
export var addToCartWrapper = "_w8-8";
export var editMode = "_w8-3";
export var headerRow = "_w8-a";
export var headerTitle = "_w8-b";
export var product = "_w8-1";
export var productDetails = "_w8-5";
export var productDivider = "_w8-7";
export var productImage = "_w8-2";
export var productInfo = "_w8-4";
export var productTitle = "_w8-6";
export var strikethrough = "_w8-9";
export var upsellProductsCard = "_w8-0";